import * as momentTZ from 'moment-timezone'

export const localTimeZone = () => {
  return momentTZ.tz.guess()
}

export const formatDateTimeWithLocalTimeZone = (dateTime) => {
  return momentTZ.tz(dateTime, localTimeZone()).format()
}

export const convertDateTimeToTimeZone = (dateTime, fromTimeZone, toTimeZone, format = 'Y-M-D HH:mm') => {
  return momentTZ.tz(dateTime, fromTimeZone).clone().tz(toTimeZone).format(format)
}
